import { Modal } from 'antd';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

const ModalWarningLeavePage: FC = () => {
  const [currentItemId, setCurrentItemId] = useState<string | undefined>(undefined);
  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  const history = useHistory<{ itemId?: string; omitWarningLeavePage?: boolean }>();

  const unblockRef = useRef<Function>();

  const handleOK = useCallback(
    async (pathname?: string, itemId?: string) => {
      if (unblockRef.current) {
        unblockRef.current();
      }
      setShowPrompt(false);
      history.push(pathname || currentPath, { itemId: itemId || currentItemId });
    },
    [currentPath, history, currentItemId],
  );

  useEffect(() => {
    unblockRef.current = history.block((prompt) => {
      if (prompt.state?.omitWarningLeavePage) {
        handleOK(prompt.pathname, prompt.state?.itemId);
      } else {
        setCurrentItemId(prompt.state?.itemId);
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
      }
      return false;
    });

    return () => {
      unblockRef.current && unblockRef.current();
    };
  }, [handleOK, history]);

  return (
    <Modal
      title="操作確認"
      centered
      visible={showPrompt}
      onOk={() => handleOK()}
      onCancel={() => setShowPrompt(false)}
      okText="OK"
      cancelText="キャンセル"
      width={600}
      closable={false}
      maskClosable={false}
    >
      <p className="clinic-room middleBoldFont" style={{ marginBottom: 0 }}>
        登録完了していません。画面を移動してよろしいですか。
      </p>
    </Modal>
  );
};

export default ModalWarningLeavePage;
